// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"style_ldsDualRing__1Ejj5","lds-dual-ring":"style_lds-dual-ring__1aQD2"};